export default __webpack_public_path__ + "static/media/content4096.21d25610.png";